import get from 'lodash/get';
import * as types from './constants';

const initialState = {
  loading: false,
  error: null,
  projectInformations: {},
  financialInformation: {},
  progressReport: {},
  latestProgressReport: {},
  serviceCharges: {},
  projectUnit: {},
  serviceChargesGroups: [],
  servicesChargesGroupData: {},
};

function developerReducers(state = initialState, action = {}) {
  switch (action.type) {
    case types.DEVELOPERS_OPERATION_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DEVELOPERS_OPERATION_END:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'Oops! Something went wrong'),
      };
    case types.FETCH_DEVELOPERS_PROJECTS:
      return {
        ...state,
        loading: false,
        projectInformations: get(action.payload, 'projectInformations', {}),
      };
    case types.FETCH_DEVELOPERS_PROJECTS_FINANCIAL:
      return {
        ...state,
        loading: false,
        financialInformation: get(action.payload, 'financialInformation', {}),
      };
    case types.FETCH_DEVELOPERS_PROGRESS_REPORT:
      return {
        ...state,
        loading: false,
        progressReport: get(action.payload, 'progressReport', {}),
      };
    case types.FETCH_DEVELOPERS_LATEST_PROGRESS_REPORT:
      return {
        ...state,
        loading: false,
        latestProgressReport: get(action.payload, 'latestProgressReport', {}),
      };
    case types.FETCH_DEVELOPERS_SERVICES_CHARGES:
      return {
        ...state,
        loading: false,
        serviceCharges: get(action.payload, 'serviceCharges', {}),
      };
    case types.FETCH_DEVELOPERS_SERVICES_CHARGES_GROUPS:
      return {
        ...state,
        loading: false,
        serviceChargesGroups: get(action.payload, 'serviceChargesGroups', []),
      };
    case types.FETCH_DEVELOPERS_SERVICES_CHARGES_GROUP_DATA:
      return {
        ...state,
        loading: false,
        servicesChargesGroupData: {
          ...state.servicesChargesGroupData,
          ...get(action.payload, 'servicesChargesGroupData', {}),
        },
      };
    case types.FETCH_DEVELOPERS_PROJECT_UNIT:
      return {
        ...state,
        loading: false,
        financialInformation: get(action.payload, 'projectUnit', {}),
      };

    case types.RESET_DEVELOPERS_STATE:
      return initialState;
    case types.FETCH_DEVELOPERS_PROFESSIONS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.ADD_TO_DEVELOPERS_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.ADD_TO_DEVELOPERS_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'message'),
      };

    case types.DOWNLOAD_TRANSACTION:
      return {
        ...state,
        query: get(action.payload, 'query'),
        loading: true,
      };
    case types.DOWNLOAD_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.DOWNLOAD_TRANSACTION_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    case types.DOWNLOAD_CERTIFICATE:
      return {
        ...state,
        query: get(action.payload, 'query'),
        loading: true,
      };
    case types.DOWNLOAD_CERTIFICATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.DOWNLOAD_CERTIFICATE_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };

    default:
      return state;
  }
}

export default developerReducers;
